import { useTranslation } from 'react-i18next'
import { InputSearch, SearchFilterGeneric, SelectFilter, cn } from '@dashboard/ui'
import { PluginCategory } from '@/api/dashboard'
import { PluginTableFilterState } from '../PluginTable'

interface PluginTableToolbarProps {
  filter: SearchFilterGeneric<PluginTableFilterState>
  getCategoryItems?: () => { children: string; value: PluginCategory }[]
}

export const PluginTableToolbar = ({ filter, getCategoryItems }: PluginTableToolbarProps) => {
  const { t } = useTranslation()

  const categoryItems = getCategoryItems
    ? getCategoryItems()
    : Object.values(PluginCategory)
        .map(category => ({
          children: t(`plugin.table.category.${category}`),
          value: category,
        }))
        .sort((a, b) => a.children.localeCompare(b.children))

  return (
    <div className={cn('mb-4 flex w-full items-center gap-2')}>
      <InputSearch {...filter.registerInput('q')} placeholder={t('search')} />

      <SelectFilter {...filter.registerSelect('category')} items={categoryItems}>
        {t('plugin.table.category')}
      </SelectFilter>
    </div>
  )
}
